// lib/auth/security-config.ts - 보안 설정 관리

export const SECURITY_CONFIG = {
  // 비활성 자동 로그아웃 설정
  INACTIVITY_TIMEOUT: {
    // 프로덕션 환경: 12시간
    PRODUCTION: {
      TIMEOUT_HOURS: 12,
      WARNING_MINUTES: 30
    },
    // 개발 환경: 6분 (테스트용)
    DEVELOPMENT: {
      TIMEOUT_HOURS: 0.1, // 6분
      WARNING_MINUTES: 1  // 1분 전 경고
    }
  },

  // 토큰 설정
  TOKENS: {
    ACCESS_TOKEN_EXPIRY: 60 * 60, // 1시간 (초)
    REFRESH_TOKEN_EXPIRY: 30 * 24 * 60 * 60, // 30일 (초)
    COOKIE_EXPIRY: 30 * 24 * 60 * 60 // 30일 (초)
  },

  // 세션 설정
  SESSION: {
    MAX_AGE: 30 * 24 * 60 * 60, // 30일 (초)
    UPDATE_AGE: 24 * 60 * 60 // 24시간마다 업데이트 (초)
  },

  // 보안 헤더 설정
  SECURITY_HEADERS: {
    'X-Frame-Options': 'DENY',
    'X-Content-Type-Options': 'nosniff',
    'Referrer-Policy': 'strict-origin-when-cross-origin',
    'X-XSS-Protection': '1; mode=block'
  }
};

// 현재 환경에 따른 설정 반환
export function getInactivityConfig() {
  const isDevelopment = process.env.NODE_ENV === 'development';
  
  return isDevelopment 
    ? SECURITY_CONFIG.INACTIVITY_TIMEOUT.DEVELOPMENT
    : SECURITY_CONFIG.INACTIVITY_TIMEOUT.PRODUCTION;
}

// 보안 설정 유효성 검사
export function validateSecurityConfig() {
  const config = getInactivityConfig();
  
  if (config.TIMEOUT_HOURS <= 0) {
    throw new Error('Invalid timeout hours configuration');
  }
  
  if (config.WARNING_MINUTES <= 0 || config.WARNING_MINUTES >= config.TIMEOUT_HOURS * 60) {
    throw new Error('Invalid warning minutes configuration');
  }
  
  return true;
} 